import { Helpers } from '../../helpers';
import { IDrillingAreaTeam } from '../../interfaces/idrilling-area-team';
import { Area } from '../area';
import { Well } from '../well';

export class DrillingAreaTeamBase {
  DrillingAreaTeamId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Areas_DrillingAreaTeam?: Array<Area> | null;
  Wells_DrillingAreaTeam?: Array<Well> | null;

  constructor(item?: IDrillingAreaTeam) {
    if (item) {

      this.DrillingAreaTeamId = item.DrillingAreaTeamId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Areas_DrillingAreaTeam = Helpers.createClassArray(Area, item.Areas_DrillingAreaTeam);
      this.Wells_DrillingAreaTeam = Helpers.createClassArray(Well, item.Wells_DrillingAreaTeam);
    }
  }
}